// extracted by mini-css-extract-plugin
export default {"ModuleselectField":"ZEsY5jodl3rKL2esTtW_"};